import { CapacityMemberCounts } from 'capacity/api/capacityGateway'
import { CapacitySummary, CountingType, LimitState } from 'capacity/types'
import { countingTypeFromWire } from 'capacity/domain/countingType'
import { toLimitState } from 'capacity/domain/limit'

export interface CapacityListRow {
    id: string
    name: string
    limit: LimitState
    countingType: CountingType
    productsCount: number | null
    optionItemsCount: number | null
}

export function buildListRows(
    capacities: CapacitySummary[],
    counts: CapacityMemberCounts | undefined,
): CapacityListRow[] {
    return (
        capacities
            .map((capacity) => ({
                id: capacity.id,
                name: capacity.name,
                limit: toLimitState(capacity.defaultAvailability),
                countingType: countingTypeFromWire(capacity.reservationPeriodType),
                productsCount: counts ? counts.counts[capacity.id]?.products ?? 0 : null,
                optionItemsCount: counts ? counts.counts[capacity.id]?.optionItems ?? 0 : null,
            }))
            // By name only: the counts land after the rows, and a row must never move on its own.
            .sort((a, b) => a.name.localeCompare(b.name))
    )
}

export const matchesSearch = (row: CapacityListRow, query: string): boolean =>
    query.trim() === '' || row.name.toLowerCase().includes(query.trim().toLowerCase())
